import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5df0d56a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-primary col-12 px-2 py-3 py-md-5 flex-centered-col bg-image" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "m-0 text-white" }, "Welcome to the Advance Profile managment screen!")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-4 py-sm-5 px-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "h3" }, "Use the sidebar to navigate")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { useHead } from "@unhead/vue";
// import { useAuthStore } from "@/stores/auth";
import { onBeforeMount, Ref, ref } from "vue";
import { useMediaQuery } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

useHead({
  title: "Home",
});

const isDesktop = useMediaQuery('(min-width: 992px)')
// const authStore = useAuthStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})